export default __webpack_public_path__ + "static/layout_cloud_front-27492c32a2c8520ae23a07996f7d7e93.png";